import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
const firebaseConfig = {
  apiKey: "AIzaSyBp40F6esU4Wt-1iBNQb5rs7VQICkfOf-U",
  authDomain: "nextgennexus-a7be2.firebaseapp.com",
  projectId: "nextgennexus-a7be2",
  storageBucket: "nextgennexus-a7be2.firebasestorage.app",
  messagingSenderId: "318532999891",
  appId: "1:318532999891:web:2dc4ac2fc0cbc597771226",
  measurementId: "G-3CGRKNRHYW"
};
const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);
export default app;